export default function AppointmentTypeSelect({ types, onSelect }) {
  const safeTypes = types || [];
  const priceFormatter = new Intl.NumberFormat("pt-PT", {
    style: "currency",
    currency: "EUR"
  });

  if (safeTypes.length === 0) {
    return (
      <div className="text-center py-8 text-muted">
        Nenhum serviço disponível para este profissional.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {safeTypes.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => onSelect(t)}
          className="w-full flex items-center justify-between p-4 bg-card border border-border rounded-lg hover:border-gold/50 transition-colors text-left"
        >
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-white mb-1">{t.name}</h3>
            <p className="text-sm text-muted">
              {t.duration_minutes} min · {priceFormatter.format(t.price ?? 0)}
            </p>
          </div>

          {/* Arrow */}
          <div className="text-gold text-xl flex-shrink-0 ml-4">→</div>
        </button>
      ))}
    </div>
  );
}
